const aButtonSecondary = {
  aButtonSecondary: {
    actions: {
      reset: 'Cancelar'
    }
  }
}

export default aButtonSecondary
